// extracted by mini-css-extract-plugin
module.exports = {"bar":"LoaderTable_bar__3uZ2F","shade":"LoaderTable_shade__jVbna"};